/**
 * KoremarginLogo — SVG logo ufficiale, coerente con koremargin.com
 * variant="compact"  → solo cerchio+K + "KOREMARGIN" (sidebar)
 * variant="full"     → logo completo con "| Financial OS" (login page)
 */

interface KoremarginLogoProps {
  variant?: 'compact' | 'full'
  className?: string
}

export function KoremarginLogo({ variant = 'full', className }: KoremarginLogoProps) {
  const gradId = variant === 'compact' ? 'km_grad_compact' : 'km_grad_full'

  if (variant === 'compact') {
    // Taglia il viewBox prima del separatore — adatto alla sidebar
    return (
      <svg
        width="160"
        height="28"
        viewBox="0 0 290 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Koremargin"
      >
        <circle cx="20" cy="25" r="18" stroke={`url(#${gradId})`} strokeWidth="2" fill="none" />
        <path
          d="M14 17V33M14 25L23 17M14 25L23 33"
          stroke={`url(#${gradId})`}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <text
          x="48"
          y="33"
          fill="white"
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: '26px',
            letterSpacing: '2px',
          }}
        >
          KOREMARGIN
        </text>
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#6366f1" />
            <stop offset="100%" stopColor="#a855f7" />
          </linearGradient>
        </defs>
      </svg>
    )
  }

  // Full — con separatore e "Financial OS"
  return (
    <svg
      width="340"
      height="38"
      viewBox="0 0 450 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Koremargin — Financial OS"
    >
      <circle cx="20" cy="25" r="18" stroke={`url(#${gradId})`} strokeWidth="2" fill="none" />
      <path
        d="M14 17V33M14 25L23 17M14 25L23 33"
        stroke={`url(#${gradId})`}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        x="48"
        y="33"
        fill="white"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 700,
          fontSize: '26px',
          letterSpacing: '2px',
        }}
      >
        KOREMARGIN
      </text>
      <text
        x="295"
        y="33"
        fill="#64748b"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 400,
          fontSize: '26px',
        }}
      >
        |
      </text>
      <text
        x="315"
        y="33"
        fill="#94a3b8"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 400,
          fontSize: '20px',
          letterSpacing: '0.5px',
        }}
      >
        Financial OS
      </text>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
